"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dateHelper = require("../../../helpers/dateHelper");
var _downloadHelper = require("../../../helpers/downloadHelper");
var _APIconButton = _interopRequireDefault(require("../../common/APIconButton/APIconButton"));
var _DownloadAPButton = _interopRequireDefault(require("../../common/DownloadAPButton"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _dateFns = require("date-fns");
var _APTable = _interopRequireDefault(require("../../common/APTable"));
require("./DownloadReportComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('download-report');
var DownloadReportComponent = function DownloadReportComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var reportWriterResults = props.reportWriterResults,
    isLoading = props.isLoading,
    getUserReportWriterResults = props.getUserReportWriterResults,
    downloadDocument = props.downloadDocument;
  var formatType = function formatType(report) {
    var summary = report.reportDescriptiveHeader.split('|');
    var startTime = (0, _dateHelper.formatDate)((0, _dateFns.subDays)(summary[2], 1));
    var endTime = (0, _dateHelper.formatDate)((0, _dateFns.subDays)(summary[3], 1));
    return "".concat(summary[0], " ").concat(summary[1], " from ").concat(startTime, " to ").concat(endTime);
  };
  var isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod/i);
  var downloadCSV = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(url, filename) {
      var response, blob, link, objectURL, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return fetch(url);
          case 1:
            response = _context.v;
            _context.n = 2;
            return response.blob();
          case 2:
            blob = _context.v;
            link = document.createElement('a');
            objectURL = URL.createObjectURL(blob);
            link.href = objectURL;
            link.setAttribute('download', filename.replace('/', '-'));

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
            URL.revokeObjectURL(objectURL);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('Failed to download CSV:', _t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 3]]);
    }));
    return function downloadCSV(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var onDownloadClick = function onDownloadClick(data) {
    var reportOutputFilePathname = data.reportOutputFilePathname,
      reportDescriptiveHeader = data.reportDescriptiveHeader;
    var filename = (0, _downloadHelper.formatReportFilename)(reportDescriptiveHeader);
    if (reportOutputFilePathname) {
      downloadCSV(reportOutputFilePathname, filename);
    } else {
      downloadDocument(data.descriptorId, filename);
    }
  };
  var columns = [{
    header: t('Report Summary'),
    classModifier: 'type',
    cell: function cell(row) {
      return formatType(row);
    }
  }, {
    header: t('Created'),
    classModifier: 'created',
    cell: function cell(row) {
      return (0, _dateFns.format)(row.reportExecutionStartTime, 'M/d/yyyy h:mmaaa');
    }
  }, !isMobile && {
    header: t('Actions'),
    classModifier: 'actions',
    cell: function cell(row) {
      return /*#__PURE__*/_react["default"].createElement(_DownloadAPButton["default"], {
        onClick: function onClick() {
          return onDownloadClick(row);
        },
        customClass: baseClass('action-btn'),
        styleName: "additive",
        text: t('Download Report')
      });
    }
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClass('container')
  }, /*#__PURE__*/_react["default"].createElement(_APIconButton["default"], {
    customClass: baseClass('refresh-reports'),
    iconName: "refresh",
    action: getUserReportWriterResults,
    showLabel: false
  }), reportWriterResults && (reportWriterResults === null || reportWriterResults === void 0 ? void 0 : reportWriterResults.length) > 0 && /*#__PURE__*/_react["default"].createElement(_APTable["default"], {
    columns: columns,
    baseClass: baseClass,
    rows: reportWriterResults,
    empty: t('No Report Is Available'),
    fetching: isLoading,
    headerOutside: true
  }));
};
DownloadReportComponent.propTypes = {
  reports: _propTypes["default"].array.isRequired,
  reportWriterResults: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = DownloadReportComponent;